import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { ContactActionPanel } from '../contactActionPanel';
import { ContactAvatar } from './components/contactAvatar';

export const ContactInfo = ({
  queryParams,
  contact,
  type,
  page,
  list,
  deleteContactFromList,
  fullContactView,
  addedToSharedList,
  trackPageEvent,
  showJobSeeking,
}) => (
  <>
    <Flex flexGrow={[0, 0, 1]} flexDirection="column">
      <ContactAvatar
        variant="large"
        contact={contact}
        trackLinkedinClick={() => trackPageEvent('contacts:view_linkedin_profile')}
        showEmailDropdown={type !== 'public'}
        showJobSeeking={showJobSeeking}
      />

      {['default', 'public'].includes(type) && (
        <Box flex="0 0 auto" mt="48px">
          <ContactActionPanel
            type={type}
            page={page}
            queryParams={queryParams}
            contact={contact}
            list={list}
            actions={type === 'public' ? ['show-importers'] : ['add-importer', 'lists', 'tags']}
            deleteContactFromList={deleteContactFromList}
            fullContactView={fullContactView}
            addedToSharedList={addedToSharedList}
          />
        </Box>
      )}
    </Flex>
  </>
);

ContactInfo.propTypes = {
  queryParams: PropTypes.object,
  contact: PropTypes.object,
  type: PropTypes.oneOf(['default', 'read', 'public']),
  page: PropTypes.string,
  list: PropTypes.object,
  deleteContactFromList: PropTypes.bool,
  fullContactView: PropTypes.bool,
  addedToSharedList: PropTypes.bool,
  trackPageEvent: PropTypes.func.isRequired,
  showJobSeeking: PropTypes.bool,
};

ContactInfo.defaultProps = {
  queryParams: {},
  contact: {},
  type: 'default',
  page: '',
  list: null,
  deleteContactFromList: false,
  fullContactView: false,
  addedToSharedList: false,
  showJobSeeking: false,
};
